import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthApiService } from '../../service/auth-api.service';
import { ResponseData } from 'src/app/helper/interface/response';
import { RESPONSE_CODE, VALIDATOR_PATTERNS } from 'src/app/helper/class/app-constant';
import { AlertService } from 'src/app/helper/service/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  
  signupForm!: FormGroup;
  showSignup = true; 

  constructor(private fb: FormBuilder,private authApi:AuthApiService,private router:Router,private alertService:AlertService) {}


  ngOnInit() {
    this.createSignupForm();
  }

  createSignupForm() {
    
    this.signupForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  onSubmit() {
    if(!this.signupForm.valid){
      this.alertService.showToast('Form Not Valid','error')
      return
    }
    
    this.authApi.signup(this.apiPayload()).then((res:ResponseData) =>{
      if(res.statusCode == RESPONSE_CODE.SUCCESS){
        this.alertService.showToast('Signup Succesfully ','success')
        this.router.navigate(['/login']);
      }
    })
    .catch((error)=>{
  
    })

    //the success output
    .finally(()=>{
     
    })

}

toggleSections() {
  this.showSignup = !this.showSignup;
}

// apiPayload() {
  
//   const payload: any = [{}]; // Initialize payload as an empty object
//   console.log('val',payload)
//   payload.username = this.signupForm.value.username;
//   payload.email = this.signupForm.value.email
//   payload.password = this.signupForm.value.password;
//   return payload;
// }

apiPayload() {
  return{
    name :this.signupForm.value.name,
    email : this.signupForm.value.email,
    password : this.signupForm.value.password,
    
  }

}



  }
